export const getDomainName = () => {
  let hostname = window.location.hostname
  return hostname.substring(
    hostname.lastIndexOf('.', hostname.lastIndexOf('.') - 1) + 1,
  )
}
